import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { Image } from '../Image/Image';
import styles from './styles';
export const Decoration = ({ asStandAlonePage, imagePath, title, titleBold, decoText, ctaButtons, imageAlt = '', }) => {
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    // const isTabletOrMobile = isTablet || !isDesktop;
    const standAloneTabletWidth = isTablet ? '35%' : '25%';
    return (_jsxs(Box, { sx: styles.decorationContainer(asStandAlonePage || false), children: [_jsxs(Box, { sx: { textAlign: 'center', mt: { mobile: 12, desktop: 4 } }, children: [_jsx(Image, { src: imagePath, alt: imageAlt }), _jsx(Typography, { variant: 'body1', sx: { mt: 3, fontSize: '28px' }, children: title }), _jsx(Typography, { variant: 'h1', sx: { mb: 3 }, children: titleBold })] }), _jsx(Typography, { variant: 'body1', sx: {
                    width: !isDesktop ? '100%' : asStandAlonePage ? standAloneTabletWidth : '45%',
                    textAlign: 'center',
                    mb: { mobile: 5, desktop: 2 },
                }, children: decoText }), ctaButtons || _jsx(_Fragment, {})] }));
};
